import React from 'react'
import ReactDOM from 'react-dom/client'
import {QueryClient, QueryClientProvider} from 'react-query'
import './index.scss'
import App from 'pages/App/App'
import {AuthProvider} from 'contexts/AuthContext'
import {ToastContainer} from 'react-toastify'
import {TabsProvider} from 'contexts/TabsContext'
import {BusinessProvider} from 'contexts/BusinessContext'
import {RealtimeProvider} from 'contexts/RealtimeContext'
import {FacebookProvider} from 'react-facebook'
import {GoogleOAuthProvider} from '@react-oauth/google'

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <QueryClientProvider client={queryClient}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <FacebookProvider appId={process.env.REACT_APP_FB_ID}>
        <TabsProvider>
          <AuthProvider>
            <BusinessProvider>
              <RealtimeProvider>
                <App />
              </RealtimeProvider>
              <ToastContainer
                style={{minWidth: '350px'}}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
                progress={undefined}
                theme="colored"
              />
            </BusinessProvider>
          </AuthProvider>
        </TabsProvider>
      </FacebookProvider>
    </GoogleOAuthProvider>
  </QueryClientProvider>
)
